export function normalizeMojibakeText(text: string): string {
  if (!/[\u00c3\u00c2]/.test(text)) {
    return text;
  }

  try {
    const bytes = Uint8Array.from(Array.from(text), (char) => char.charCodeAt(0) & 0xff);
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return text.replace(/(?:[\u00c3\u00c2][\u0080-\u00ff])+/g, (segment) => {
      try {
        const bytes = Uint8Array.from(Array.from(segment), (char) => char.charCodeAt(0) & 0xff);
        return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
      } catch {
        return segment;
      }
    });
  }
}

export function normalizeApiText<T>(value: T): T {
  if (typeof value === 'string') {
    return normalizeMojibakeText(value) as unknown as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => normalizeApiText(item)) as unknown as T;
  }

  if (value && typeof value === 'object') {
    const normalized: Record<string, unknown> = {};

    Object.entries(value as Record<string, unknown>).forEach(([key, item]) => {
      normalized[key] = normalizeApiText(item);
    });

    return normalized as T;
  }

  return value;
}
